<template>
<div class="chapter">
<div class="inner_page">
<p class="fmtxth">PRAISE FOR DESTINY SORIA’S</p>
<p class="fmtxth1"><strong><em>IRON CAST</em></strong></p>
<p class="fmtxt"><img alt="Images" class="inline" src="images/star.jpg"/> “Energetic and original, this alternative history, fantasy, and mystery mashup with its pair of smart, resourceful, flawed but engaging heroines never disappoints.”<br/>—<em>Kirkus Reviews</em>, starred review</p>
<p class="fmtxt"><img alt="Images" class="inline" src="images/star.jpg"/> “Hand this entrancing historical fantasy to fans of Libba Bray’s Diviners series or anyone who likes their magic on the seamier side.”<br/>—<em>Booklist</em>, starred review</p>
<p class="fmtxt"><img alt="Images" class="inline" src="images/star.jpg"/> “Stories of the diverse cast of flawed and complicated characters striving to do better complement the solid female friendship at the core of this absorbing novel . . . Mystery and fantasy blend well in this witty title filled with twists and fast-paced action.”<br/>—<em>School Library Journal</em>, starred review</p>
<p class="fmtxt">“Destiny Soria’s debut is without a doubt one of the best of the year.”<br/>—<em>YA Books Central</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// praise.vue?6e19b7cc